<!--tag -->
<template>
  <div class="tags" v-if="showTags">
    <ul>
      <li
        class="tags-li"
        v-for="(item, index) in tagsList"
        :style="{ 'max-width': width + '%' }"
        :class="{ active: isActive(item.path) }"
        :key="index"
      >
        <el-tooltip
          class="item"
          effect="dark"
          :content="item.title"
          placement="bottom"
        >
          <router-link :to="item.path" class="tags-li-title">
            {{ item.title }}
          </router-link>
        </el-tooltip>
        <span class="tags-li-icon" @click="closeTags(index)"
          ><i class="el-icon-close"></i
        ></span>
      </li>
    </ul>

    <div class="tags-close-box">
      <el-dropdown @command="handleTags">
        <el-button size="mini" type="primary">
          标签选项<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu size="small" slot="dropdown">
          <el-dropdown-item command="other">关闭其他</el-dropdown-item>
          <el-dropdown-item command="all">关闭所有</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import bus from "@/utils/bus"
export default {
  data() {
    return {
      tagsList: [],
      width: "5",
    }
  },
  methods: {
    isActive(path) {
      return path === this.$route.fullPath
    },
    // 关闭单个标签
    closeTags(index) {
      const delItem = this.tagsList.splice(index, 1)[0]
      const item = this.tagsList[index]
        ? this.tagsList[index]
        : this.tagsList[index - 1]
      if (item) {
        delItem.path === this.$route.fullPath && this.$router.push(item.path)
      } else {
        this.$router.push("/")
      }
    },
    // 关闭全部标签
    closeAll() {
      this.tagsList = []
      this.$router.push("/")
    },
    // 关闭其他标签
    closeOther() {
      const curItem = this.tagsList.filter((item) => {
        return item.path === this.$route.fullPath
      })
      this.tagsList = curItem
    },
    // 设置标签
    setTags(route) {
      const isExist = this.tagsList.some((item) => {
        return item.path === route.fullPath
      })
      if (!isExist) {
        if (this.tagsList.length >= 100) {
          this.tagsList.shift()
        }
        this.tagsList.push({
          title: route.meta.title,
          path: route.fullPath,
          name: route.matched[1].components.default.name,
        })
      }
      if (this.tagsList.length > 10) {
        this.width = 100 / (this.tagsList.length * 1.5)
      } else {
        this.width = 8
      }

      bus.$emit("tags", this.tagsList)
    },
    handleTags(command) {
      command === "other" ? this.closeOther() : this.closeAll()
    },
  },
  computed: {
    showTags() {
      return this.tagsList.length > 0
    },
  },
  watch: {
    $route(newValue, oldValue) {
      this.setTags(newValue)
    },
  },
  created() {
    this.setTags(this.$route)
    // 监听关闭当前页面的标签页
    bus.$on("close_current_tags", () => {
      for (let i = 0, len = this.tagsList.length; i < len; i++) {
        const item = this.tagsList[i]
        if (item.path === this.$route.fullPath) {
          if (i < len - 1) {
            this.$router.push(this.tagsList[i + 1].path)
          } else if (i > 0) {
            this.$router.push(this.tagsList[i - 1].path)
          } else {
            this.$router.push("/")
          }
          this.tagsList.splice(i, 1)
          break
        }
      }
    })

    bus.$on("close_all_tags", () => {
      this.closeAll()
    })
    bus.$on("close_tag", (path) => {
      for (let i = 0, len = this.tagsList.length; i < len; i++) {
        const item = this.tagsList[i]
        if (item.path === path) {
          this.tagsList.splice(i, 1)
          break
        }
      }
    })
  },
}
</script>

<style>
.tags {
  height: 40px;
  overflow: hidden;
  background: #fff;
  padding-right: 120px;
  box-shadow: 0 5px 10px #ddd;
  z-index: 1000;
  position: absolute;
  width: calc(100vw - 359px);
  left: 217px;
  z-index: 0;
  /* margin-top: 50px; */
  margin-top: 60px;
}

.tags ul {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* padding: 2px 0 0 0; */
}

.tags-li {
  float: left;
  font-size: 12px;
  overflow: hidden;
  cursor: pointer;
  height: 42px;
  line-height: 42px;
  border-right: 1px solid #e9eaec;
  background: #fff;
  padding: 0 4px 0 12px;
  vertical-align: middle;
  color: #666;
  -webkit-transition: all 0.3s ease-in;
  -moz-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
  outline: none;
  position: relative;
}

.tags-li.active::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 2px;
  border-radius: 0;
  background-color: #292b34;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  width: 100%;
  border: none;
  height: 2px;
}

.tags-li:not(.active):hover {
  background: #f8f8f8;
}
.tag-li:focus {
  outline: none !important;
}

.tags-li.active {
  /* color: #fff; */
}

.tags-li-title {
  float: left;
  max-width: 85%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 12px;
  color: #666;
  border: none;
  outline: none;
}
.tags-li-title:focus {
  outline: none;
}

.tags-li.active .tags-li-title {
  /* color: #fff; */
}

.tags-close-box {
  position: absolute;
  right: 8px;
  top: 5px;
  box-sizing: border-box;
  padding-top: 1px;
  text-align: center;
  height: 30px;
  background: #fff;
  box-shadow: -3px 0 15px 3px rgba(0, 0, 0, 0.1);
  z-index: 10;
}
.tags-li-icon {
  right: 2px;
  top: 0px;
  position: absolute;
}
</style>
